import { gql } from "@apollo/client";

export const CALL_DIAL = gql`
  mutation CallDial($phoneNumber: String!, $contactId: ID!, $projectId: ID!) {
    callDial(
      phoneNumber: $phoneNumber
      contactId: $contactId
      projectId: $projectId
    ) {
      success
      message
      callId
    }
  }
`;

const calls = { CALL_DIAL };

export default calls;
